import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
//import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { NumberFormatter } from '../components/numberFormatter';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';
import Cookies from 'js-cookie';
import { GetAgoTime } from '../components/getAgoTime';
//help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { VscVerifiedFilled } from "react-icons/vsc";
import { MdDone } from 'react-icons/md';
//page links  
import { Randomcode } from '../components/rendom_code';
import { useToast } from '../components/ToastContext';
import { VscCalendar } from "react-icons/vsc";
import Photosicon from '../assets/photos_icon.png';
import { FaSave, FaStar } from "react-icons/fa";
import { Savesubscriber } from '../profile_root/Save_subscriber';
import Statusbar from '../master_root/statusbar';
import { MdSend, MdOutlineMoveToInbox } from 'react-icons/md';
import { Savemessagesystem } from '../messaging_root/save_messagesystem';
import PhoneCodeList from '../components/PhoneCodeList';
import './messageing.css';
import { MdOutlineDelete, MdArrowBack, MdModeEditOutline } from "react-icons/md";
export default function Messaging() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [inboxData, setInboxData] = useState([]);
  const [messageData, setMessageData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [subjact, setSubjact] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('null');
  const [selectedCode, setSelectedCode] = useState(null);
  const [countryname, setSelectedcountryname] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accountguid, setAccountguid] = useState();
  const [messageopen, setMessageopen] = useState(false);
  const [inboxtab, setinboxtab] = useState('inbox');

  useEffect(() => {
    fetchFeedsData();
  }, []);
  const fetchmessageData = async (uid) => {
    try {

      const smsQuery = query(
        collection(db, "messagesystem"),
        where("uid", "==", uid)
      );

      const smsSnapshot = await getDocs(smsQuery);

      const dataList = await Promise.all(
        smsSnapshot.docs.map(async (docItem) => {
          const smsData = { id: docItem.id, ...docItem.data() };

          const detailsQuery = query(
            collection(db, "users"),
            where("guid", "==", smsData.guid)
          );
          setAccountguid(smsData.guid);
          const detailsSnapshot = await getDocs(detailsQuery);
          const userData =
            detailsSnapshot.docs.map((detailsDoc) => ({
              uid: detailsDoc.id,
              ...detailsDoc.data(),
            }))[0] || null;

          return {
            ...smsData,
            userData
          };
        })
      );
      setMessageopen(true);
      setMessageData(dataList);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoading(false);
    }
  }
  const closemessage = async () => {
    setMessageopen(false);
  }
  const fetchFeedsData = async () => {
    try {
      const smsQuery = query(
        collection(db, "messagesystem"),
        where("save", "==", false)
      );
      const smsSnapshot = await getDocs(smsQuery);
      const dataList = await Promise.all(
        smsSnapshot.docs.map(async (docItem) => {
          const smsData = { id: docItem.id, ...docItem.data() };
          const detailsQuery = query(
            collection(db, "users"),
            where("guid", "==", smsData.guid)
          );
          const detailsSnapshot = await getDocs(detailsQuery);
          const userData =
            detailsSnapshot.docs.map((detailsDoc) => ({
              uid: detailsDoc.id,
              ...detailsDoc.data(),
            }))[0] || null;

          return {
            ...smsData,
            userData
          };
        })
      );
      setInboxData(dataList);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const submit_contacts = async () => {
    if (accountguid == Cookies.get("guid")) {
      showToast("This is not allowed");
      return;
    }
    if (!countryname || !subjact || !phone || !message) {
      return;
    }
    setLoading(true);
    try {
      // Generate a random UID
      const uid = Randomcode(12);
      // Await the result of saving the message
      const result = await Savemessagesystem({
        uid,
        phonecountry: countryname,
        phonecodes: selectedCode.replace("+", ""),
        phone: selectedCode.replace("+", "") + phone,
        subjact,
        accountguid: accountguid,
        category: "contact",
        message: message,
      });
      if (result.success) {
        showToast("Sent successfully");

      } else {
        const errorMessage = result.error || "Unknown error";
        showToast("Failed: " + errorMessage);

      }
    } catch (ex) {
      console.error("An error occurred:", ex);
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (selectedOption) => {
    setSelectedCode(selectedOption);
    const countryName = selectedOption.label.split(" (")[0];
    setSelectedCode(selectedOption.value);
    setSelectedcountryname(countryName);

  };

  return (
    <div>
      <Statusbar data="Messaging" />
      <div className="app_header_height"></div>

      <div className="container_roots">
<Helmet>
  <title>Messages | EditorTask - Communicate with Clients & Creatives</title>
  <meta name="description" content="Manage your messages on EditorTask. Stay connected with clients and creative professionals. Access your inbox, sent, and starred messages securely." />
  <meta name="keywords" content="EditorTask messages, client communication, inbox, sent messages, starred, creative messaging, editor chat, secure messages" />
  <meta name="author" content="editortask.com" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Messages | EditorTask - Communicate with Clients & Creatives" />
  <meta property="og:description" content="Use the messaging panel to chat with editors, marketers, designers, and clients on EditorTask. Manage conversations easily." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/messages" />
  <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
</Helmet>

        <div className="container_size">
         
          <div className="post-container">
            <div className="post_updates">
              <div className='button-ui new-message' ><MdModeEditOutline className='icon' />New Message</div>
              <div
                className={`inbox-tab ${inboxtab === 'inbox' ? 'activetab' : ''}`}
                onClick={() => {
                  setinboxtab('inbox');
                  closemessage();
                }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td><MdOutlineMoveToInbox className="icon" /></td>
                      <td style={{ width: '100%' }}><a className='tab-title-text'>Inbox</a></td>
                      <td>0</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                className={`inbox-tab ${inboxtab === 'Sent' ? 'activetab' : ''}`}
                onClick={() => setinboxtab('Sent')}
              >
                <table>
                  <tbody>
                    <tr>
                      <td><MdSend className="icon" /></td>
                      <td style={{ width: '100%' }}><a className='tab-title-text'>Sent</a></td>
                      <td>0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className={`inbox-tab ${inboxtab === 'Starred' ? 'activetab' : ''}`}
                onClick={() => setinboxtab('Starred')}
              >
                <table>
                  <tbody>
                    <tr>
                      <td><FaStar className="icon" /></td>
                      <td style={{ width: '100%' }}><a className='tab-title-text'>Starred</a></td>
                      <td>0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="post_div" style={{ padding: '0px 20px' }}>
              {messageopen === false ? (
              
                <div className="ui-grid" >
                  {isLoading ? (
                    <Loadingimg />
                  ) : inboxData.length === 0 ? (
                    <p>No Message available.</p>
                  ) : (
                    <>
       
                 
                    <table style={{ width: '100%' }}>
                      <tbody >
                        {inboxData.map((message) => (
                          <tr
                            style={{ cursor: 'pointer' }}
                            className="ui-items messageing"
                            onClick={() => fetchmessageData(message.uid)}
                            key={message.id}
                          >
                            <td width="50px">
                              <img
                                src={message.userData?.photoURL || Photosicon}
                                alt="User"
                                className="ui-photo-img"
                              />
                            </td>
                            <td>
                              <div style={{ width: '100%' }}>
                                <div className="ui-title-text">
                                  {message.subjact?.substring(0, 150)}
                                </div>
                                <div className="ui-info-text">
                                  {message?.date_time?.toDate?.()?.toLocaleString?.() || 'No subject'}
                                </div>
                              </div>
                            </td>
                            <td style={{ width: '30px', textAlign: 'center' }}>
                              {message?.read === false && (
                                <div className="alert-text">1</div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                      </>
                  )}
                </div>
 
              ) : (
                <div className="messageing-open">
                  {isLoading ? (
                    <Loadingimg />
                  ) : messageData.length === 0 ? (
                    <p>No Message Select</p>
                  ) : (
                    <>
                      {messageData.map((message) => (
                        <>
                          <div className='menu-div'>
                            <table className='menu-table'>
                              <tr>
                                <td><MdArrowBack onClick={closemessage} className='icon' /></td>
                                <td><MdOutlineDelete className='icon' /></td>
                                <td><MdOutlineDelete className='icon' /></td>
                                <td><FaStar className='icon' /></td>
                              </tr>
                            </table>

                          </div>
                          <div
                            onClick={() => fetchmessageData(message.uid)}
                            key={message.id}
                          >
                            <table>
                              <tbody >
                                <tr>
                                  <td width={'80px'}>
                                    <img
                                      src={message.userData?.photoURL || Photosicon}
                                      alt="User"
                                      className="photo-img"
                                    />
                                  </td>
                                  <td>
                                    <table>
                                      <tr>
                                        <td>
                                          <div className="ui-title-text">
                                            {message.subjact?.substring(0, 50)}
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="ui-info-text">
                                            {message?.date_time?.toDate?.()?.toLocaleString?.() || 'No subject'}<br />

                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="ui-title-text">+
                                          {message?.phone || 'No subject'}<br />

                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="message-text">
                              {message?.message || 'No date'}
                            </div>
                            <br />
                            <div className="from-message-text">
                              <table >
                                <tr>
                                  <td ><b>From</b>
                                  </td>
                                </tr>
                                <tr>
                                  <td >
                                    {message?.city || ''}
                                  </td>
                                </tr>
                                <tr>
                                  <td >
                                    {message?.state || ''}
                                  </td>
                                </tr>
                                <tr>
                                  <td >
                                    {message?.country || ''}
                                  </td>
                                </tr>
                              </table>
                            </div>

                          </div>
                          <div>
                            <table className='reply-message' >
                              <br />
                              <tr><td>

                                <PhoneCodeList
                                  options={selectedCode}
                                  placeholder="Select country code"
                                  onChange={handleChange}
                                />

                              </td>
                              </tr>
                              <tr><td>
                                <input
                                  id='phone-input'
                                  className="message-input"
                                  maxLength={20}
                                  value={phone}
                                  onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                    setPhone(onlyNums);
                                  }}
                                  placeholder="Enter Mobile number"
                                /> </td></tr>
                              <tr><td>

                                <input className='message-input' maxLength={50} value={subjact} onChange={(e) => setSubjact(e.target.value)} placeholder='Enter Subjact'></input>
                              </td></tr>
                              <tr><td>

                                <textarea rows='6' className='message-input' maxLength={500} onChange={(e) => setMessage(e.target.value)} placeholder='Enter Message'></textarea>
                              </td></tr>
                              <tr><td>

                                <div >
                                  <div className='button-ui' onClick={submit_contacts} >
                                    {loading ? <Loadingimg /> : <MdSend className='icon' />}
                                    Submit</div>
                                </div>


                              </td></tr>
                            </table>
                          </div>
                        </>
                      ))}
                    </>
                  )}
                </div>
              )}



            </div>
               <div className="post_updates">
                               <div className="post-container">
            <div className="contact-title">📨 
            Messaging Guide | EditorTask
            </div>
          </div>
<div > 
  <p><strong>Inbox:</strong> View received messages. Unread messages show a red alert badge.</p>
  <p><strong>Sent:</strong> Review messages you’ve sent to others.</p>
  <p><strong>Starred:</strong> Access important messages you've marked for quick reference.</p>
  <p><strong>Click a message</strong> to view full content and mark it as read.</p>
  <p><strong>Tabs:</strong> Use the sidebar tabs to switch between Inbox, Sent, and Starred messages.</p>
  <p><strong>Secure & Private:</strong> All messages are protected within your account.</p>
  <p>Need help? Contact <a href="mailto:support@editortask.com">support@editortask.com</a>.</p>
</div>
               </div>
          </div>
        </div>
      </div>
    </div >
  );
}
